module.exports = __webpack_public_path__ + "static/media/RUR_rank.1805a0d5.csv";